import React from "react";
import { Badge, Button, Col, Row } from "react-bootstrap";
import { PlayFill, StopFill, Trash } from "react-bootstrap-icons";

type EventStreamControlsProps = {
    isConnected: boolean;
    secondsRemaining: number;
    eventCount: number;
    wsConfigured: boolean;
    onStart: () => void;
    onStop: () => void;
    onClear: () => void;
    error: string | null;
}

function formatCountdown(seconds: number): string {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s.toString().padStart(2, "0")}`;
}

const EventStreamControls: React.FC<EventStreamControlsProps> = ({
    isConnected,
    secondsRemaining,
    eventCount,
    wsConfigured,
    onStart,
    onStop,
    onClear,
    error
}) => {
    return (
        <Row className="align-items-center" style={{ marginBottom: "10px", gap: "8px" }}>
            <Col md="auto">
                {isConnected ? (
                    <Button variant="danger" size="sm" onClick={onStop}>
                        <StopFill /> Stop
                    </Button>
                ) : (
                    <Button variant="success" size="sm" onClick={onStart} disabled={!wsConfigured}>
                        <PlayFill /> Start
                    </Button>
                )}
            </Col>
            <Col md="auto">
                <Button variant="outline-secondary" size="sm" onClick={onClear} disabled={eventCount === 0}>
                    <Trash /> Clear
                </Button>
            </Col>
            <Col md="auto">
                {error ? (
                    <Badge variant="danger">{error}</Badge>
                ) : isConnected ? (
                    <Badge variant="success">Connected</Badge>
                ) : (
                    <Badge variant="secondary">Idle</Badge>
                )}
            </Col>
            {isConnected && (
                <Col md="auto" style={{ fontFamily: "monospace", fontSize: "0.9em" }}>
                    {formatCountdown(secondsRemaining)} remaining
                </Col>
            )}
            {secondsRemaining === 300 && !isConnected && eventCount === 0 && !error && !wsConfigured && (
                <Col md="auto" style={{ color: "#999", fontSize: "0.85em" }}>
                    WebSocket not configured for this customer.
                </Col>
            )}
            <Col md="auto" style={{ fontSize: "0.85em", color: "#888" }}>
                {eventCount} events received
            </Col>
        </Row>
    );
};

export default EventStreamControls;
